<template>
  <div class="member-service">
    <div class="aboutDlabel_content">
      <p>
    <span style=";font-family:思源黑体;font-size:14px">隐私政策</span>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px"><span style="font-family:思源黑体">我们的隐私政策将于</span>2021 年 </span><span style=";font-family:思源黑体;font-size:14px">12</span><span style=";font-family:思源黑体;font-size:14px">&nbsp;<span style="font-family:思源黑体">月</span> </span><span style=";font-family:思源黑体;font-size:14px">03</span><span style=";font-family:思源黑体;font-size:14px">&nbsp;<span style="font-family:思源黑体">日生效。自该日起，本隐私政策可以提供有关我们如何管理您的</span></span><span style=";font-family:思源黑体;font-size:14px">云联</span><span style=";font-family:思源黑体;font-size:14px">产品和服务的个人信息的隐私详情。请花点时间熟悉我们的隐私政策，如果您有任何问题，请告诉我们。</span>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px">&nbsp;</span>
</p>
<p>
    <strong><span style="font-family: 思源黑体;font-size: 14px">我们对您的承诺</span></strong>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px">您的隐私对我们非常重要。本隐私政策是一项涵盖</span><span style=";font-family:思源黑体;font-size:14px">云联</span><span style=";font-family:思源黑体;font-size:14px">应用隐私方面的声明和承诺，是</span><span style=";font-family:思源黑体;font-size:14px">云联</span><span style=";font-family:思源黑体;font-size:14px">隐私政策不可分割的一部分</span><span style=";font-family:思源黑体;font-size:14px">，</span><span style=";font-family:思源黑体;font-size:14px">我们建议您仔细阅读</span><span style=";font-family:思源黑体;font-size:14px">云联</span><span style=";font-family:思源黑体;font-size:14px">隐私政策</span><span style=";font-family:思源黑体;font-size:14px">。</span>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px">最终，我们希望为我们的用户提供最好的体验。如果您对本隐私政策中所述的我们的数据处理做法有任何疑问，请与我们联系，以便我们能够回应您的具体问题。我们很乐意收到您的任何反馈。</span>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style="font-family: 思源黑体;letter-spacing: 0;font-weight: bold;font-size: 14px">一、</span><strong><span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">关于数据储存</span></strong>
</p>
<p>
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">本应用可在非联网的状态下使用，不和云端有任何数据交互，关于应用的图片、保存的标签会储存在用户的手机中，若删除应用，保存的标签数据会一并删除，将无法找回。因删除应用造成保存的标签数据丢失，我们不承担此责任。</span>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px">&nbsp;</span>
</p>
<p>
    <strong><span style="font-family: 思源黑体;font-size: 14px">二、获取的权限</span></strong>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px">为提供基本服务，</span><span style=";font-family:思源黑体;font-size:14px">本应用</span><span style=";font-family:思源黑体;font-size:14px">需要向您申请以下权限，保证</span><span style=";font-family:思源黑体;font-size:14px">应用</span><span style=";font-family:思源黑体;font-size:14px">正常运行：</span>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px">（一）</span><span style=";font-family:思源黑体;font-size:14px">手机储存权限</span>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px"><span style="font-family:思源黑体">此权限允许</span>APP将数据存入或读取，以保证基础功能的使用，如缓存个性字体、标签文件。（</span><span style=";font-family:思源黑体;font-size:14px">二</span><span style=";font-family:思源黑体;font-size:14px">）相机权限</span>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px"><span style="font-family:思源黑体">此权限允许</span>APP访问相机，以正常使用扫一扫功能，便于提取条形码和二维码，提升工作效率。</span>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px">&nbsp;</span>
</p>
<p>
    <strong><span style="font-family: 思源黑体;font-size: 14px">三</span></strong><strong><span style="font-family: 思源黑体;font-size: 14px">、联系我们</span></strong>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px"><span style="font-family:思源黑体">如果您对本隐私政策有任何问题或反馈，或者您对我们如何收集、使用或披露您的个人信息有任何疑问，请与我们联系支持并提及您的信息涉及</span>“隐私政策”。我们专门的响应团队将能够处理您可能遇到的有关权利请求。如果您有需要解决的特别关键的问题，我们可能会要求您向我们提供更多信息。</span>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px">邮箱：</span><a href="mailto:yunlian601@gmail.com"><span style="text-decoration:underline;"><span style="font-family: 思源黑体;color: rgb(0, 0, 255)"><span style="font-family:思源黑体">yunlian601@gmail.com</span></span></span></a>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px">云联</span>
</p>
<p>
    <br/>
</p>
    </div>
  </div>
</template>

<script>
export default {
  created() {
      
    document.querySelector('title').innerHTML = '隐私政策'
    setTimeout(() => {
      document.body.scrollTop = 0;
    }, 0);
  },
};
</script>

<style lang="scss" scoped>
.member-service {
  padding: 0.4rem 0.4rem;
}
</style>